<template>
  <div class="media-library">
    <!-- Main Media Display -->
    <div class="main-media mb-3 text-center">
      <component :is="getMediaTag(selectedMedia)" :src="selectedMedia.src" controls v-if="selectedMedia.type === 'video'" class="img-fluid" height="420px" />
      <img v-else :src="selectedMedia.src" class="img-fluid" @click="openModal(selectedIndex)" style="cursor: pointer;" height="420px" />
    </div>

    <!-- Thumbnails (Responsive) -->
    <div class="row">
      <div
          v-for="(media, index) in mediaList.slice(0, 4)"
          :key="index"
          class="col-6 col-sm-4 col-md-3 col-lg-2 mb-2"
          @click="selectMedia(index)"
      >
        <div class="thumbnail-wrapper" style="cursor: pointer;">
          <component
              :is="getMediaTag(media)"
              :src="media.src"
              controls
              v-if="media.type === 'video'"
              class="img-fluid"
              style="max-height: 100px;"
          />
          <img
              v-else
              :src="media.src"
              class="img-fluid border"
              :class="{'border-primary': index === selectedIndex}"
              style="max-height: 100px; object-fit: cover;"
          />
        </div>
      </div>
    </div>

    <!-- Modal Viewer (Responsive) -->
    <div v-if="isModalOpen" class="modal-overlay" @click="closeModal">
      <div class="modal-dialog" @click.stop>
        <div class="modal-content">
          <div class="modal-body text-center">
            <button type="button" class="close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>

            <component
                :is="getMediaTag(modalMedia)"
                :src="modalMedia.src"
                controls
                v-if="modalMedia.type === 'video'"
                class="img-fluid"  style="max-height: 500px; object-fit: cover;"
            />
            <img v-else :src="modalMedia.src" class="img-fluid"  style="max-height: 500px; object-fit: cover;" />

            <div class="d-flex justify-content-between mt-3">
              <button class="btn btn-outline-secondary" @click="prevMedia">Prev</button>
              <button class="btn btn-outline-secondary" @click="nextMedia">Next</button>
            </div>

            <!-- Thumbnail inside modal (Responsive) -->
            <div class="row mt-3">
              <div
                  v-for="(media, index) in mediaList"
                  :key="'modal-' + index"
                  class="col-2 col-sm-2 col-md-1 col-lg-1"
                  @click="selectModalMedia(index)"
              >
                <img
                    v-if="media.type === 'image'"
                    :src="media.src"
                    class="img-fluid border"
                    :class="{'border-primary': index === modalIndex}"
                    style="max-height: 100px; object-fit: cover;"
                />
                <video
                    v-else
                    :src="media.src"
                    class="img-fluid border"
                    :class="{'border-primary': index === modalIndex}"
                    style="max-height: 1000px; object-fit: cover;"
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MediaLibrary",
  data() {
    return {
      selectedIndex: 0,
      modalIndex: 0,
      isModalOpen: false,
      mediaList: [
        { type: "image", src: "https://cdn1.epicgames.com/offer/cbd5b3d310a54b12bf3fe8c41994174f/EGS_VALORANT_RiotGames_S1_2560x1440-b7a9ac9bd8164de332a5fc9a2ad73f45" },
        { type: "image", src: "https://cdn1.epicgames.com/offer/cbd5b3d310a54b12bf3fe8c41994174f/EGS_VALORANT_RiotGames_S1_2560x1440-b7a9ac9bd8164de332a5fc9a2ad73f45" },
        { type: "image", src: "https://cdn1.epicgames.com/offer/cbd5b3d310a54b12bf3fe8c41994174f/EGS_VALORANT_RiotGames_S1_2560x1440-b7a9ac9bd8164de332a5fc9a2ad73f45" },
        { type: "video", src: "https://youtu.be/OHzUoFKPUB0" },
        { type: "image", src: "https://cdn1.epicgames.com/offer/cbd5b3d310a54b12bf3fe8c41994174f/EGS_VALORANT_RiotGames_S1_2560x1440-b7a9ac9bd8164de332a5fc9a2ad73f45" },
        { type: "video", src: "https://youtu.be/OHzUoFKPUB0" },
        { type: "video", src: "https://youtu.be/OHzUoFKPUB0" },
        { type: "image", src: "https://cdn1.epicgames.com/offer/cbd5b3d310a54b12bf3fe8c41994174f/EGS_VALORANT_RiotGames_S1_2560x1440-b7a9ac9bd8164de332a5fc9a2ad73f45" },
        { type: "video", src: "https://youtu.be/OHzUoFKPUB0" },
      ],
    };
  },
  computed: {
    selectedMedia() {
      return this.mediaList[this.selectedIndex];
    },
    modalMedia() {
      return this.mediaList[this.modalIndex];
    },
  },
  methods: {
    selectMedia(index) {
      this.selectedIndex = index;
    },
    openModal(index) {
      this.modalIndex = index;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    selectModalMedia(index) {
      this.modalIndex = index;
    },
    prevMedia() {
      this.modalIndex = (this.modalIndex - 1 + this.mediaList.length) % this.mediaList.length;
    },
    nextMedia() {
      this.modalIndex = (this.modalIndex + 1) % this.mediaList.length;
    },
    getMediaTag(media) {
      return media.type === 'video' ? 'video' : 'img';
    },
  },
};
</script>

<style scoped>
.img-fluid{

}
.thumbnail-wrapper img,
.thumbnail-wrapper video {
  max-height: 100px;
  object-fit: cover;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-dialog {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  max-width: 90%;
  overflow-y: auto;
  position: relative;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 2rem;
  background: none;
  border: none;
  color: #000;
}

@media (max-width: 576px) {
  .modal-dialog {
    max-width: 95%;
  }
}
</style>
